<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <!-- Tags Table -->
        <tables-event-management-table
          :items="displayTags"
          :icon="tableIcon"
          :title="tableTitle"
          :buttons="tableButtons"
          :headers="tableHeaders"
          :no-data-message="noDataMessage"
          :show-actions="canManageTags"
          @edit="editItem"
          @delete="deleteItem"
          @addTag="handleAddTag"
        />

        <!-- Delete Confirmation Dialog -->
        <dialogs-delete-confirmation-dialog
          v-model="dialogDelete"
          title="Are you sure you want to delete this Tag?"
          @confirm="deleteItemConfirm"
          @cancel="closeDelete"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import "izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "StallTags",
  data: () => ({
    dialogDelete: false,

    // Table configuration
    tableIcon: "mdi-tag",
    tableTitle: "Stall Tags",
    noDataMessage: "No tags for this event",

    editedIndex: -1,
    editedItem: {
      StallTagName: "",
      StallTagId: "",
    },
    defaultItem: {
      StallTagName: "",
      StallTagId: "",
    },
  }),

  computed: {
    ...mapState("admin", [
      "currentEvent",
    ]),
    ...mapState("filter", ["allStallTags", "globalEventFilter", "IsAdmin"]),

    eventPermission() {
      return this.globalEventFilter?.Permission || "None";
    },

    canManageTags() {
      return this.IsAdmin || this.eventPermission === "Write";
    },

    tableButtons() {
      if (!this.canManageTags) return [];
      return [
        {
          name: "Add Stall Tag",
          icon: "mdi-plus",
          function: "addTag",
        },
      ];
    },

    tableHeaders() {
      const headers = [{ text: "Tag Name", value: "StallTagName" }];
      if (this.canManageTags) {
        headers.push({ text: "Actions", value: "actions", sortable: false });
      }
      return headers;
    },

    displayTags() {
      if (!this.IsAdmin && this.eventPermission === "None") return [];
      return this.allStallTags || [];
    },
  },

  watch: {
    dialogDelete(val) {
      if (!val) {
        this.closeDelete();
      }
    },
  },

  methods: {
    ...mapMutations("admin", []),
    ...mapActions("admin", ["createEvent", "getEventMetadata"]),

    editItem(item) {
      if (!this.canManageTags) return;
      this.$router.push({
        name: "Tag Configuration",
        params: {
          id: item.StallTagId,
          tagData: item,
        },
      });
    },

    deleteItem(item) {
      if (!this.canManageTags) return;
      this.editedIndex = this.displayTags.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      try {
        if (this.editedItem.StallTagId) {
          const eventItem = [
            {
              Type: "StallTag",
              Action: "delete",
              Properties: { StallTagId: this.editedItem.StallTagId },
            },
          ];

          await this.createEvent({ event_items: eventItem });

          if (this.currentEvent?.EventId) {
            await this.getEventMetadata(this.currentEvent.EventId);
          }
        }

        iziToast.success({
          title: "Tag",
          message: "Successfully deleted record!",
          position: "topRight",
        });
      } catch (error) {
        console.error("Delete error:", error);
        iziToast.warning({
          title: "Tag",
          message: "Failed to delete record!",
          position: "topRight",
        });
      }

      this.closeDelete();
    },

    close() {
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    handleAddTag() {
      if (!this.canManageTags) return;
      this.$router.push({
        name: "Tag Configuration",
        params: { id: 0 },
      });
    },
  },
};
</script>

<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
p {
  color: #6e6e6e;
  font-family: sans-serif;
}
</style>
